import { Button, ButtonGroup, Text, useToast, VStack } from "@chakra-ui/react"
import React from "react"
import { NavLink, useNavigate } from "react-router-dom"

import { ExtendedUserFragment } from "../../graphql"
import { useWhitelistUserMutation } from "../../graphql/generated"
import { UserTag } from "../common"

export type WhiteListUserProps = {
	user: ExtendedUserFragment
}

export const WhiteListUser: React.FC<WhiteListUserProps> = ({ user }) => {
	const [{ fetching }, whitelist] = useWhitelistUserMutation()

	const toast = useToast()
	const navigate = useNavigate()

	const handleWhitelisting = async () => {
		const { error, data } = await whitelist({ userId: user._id })

		if (error) {
			toast({ description: error.message.replace("[GraphQL] ", ""), status: "error" })
			return
		}

		if (data?.whitelistUser) {
			toast({ description: "Whitelisted the user successfully", status: "success" })
			navigate(`/users/${user._id}`)
			return
		} else {
			toast({ description: "Couldn't whitelist the user", status: "error" })
			return
		}
	}

	return (
		<VStack w="full" maxW={{ base: "full", xl: "2xl" }} align="stretch" spacing={4}>
			<UserTag user={user} />
			<VStack w="full" align="flex-end" spacing={4}>
				<Text fontSize="sm" color="grayscale.label" alignSelf="flex-start">
					Are you sure you want to whitelist {user.name}?
				</Text>
				<ButtonGroup>
					<Button size="sm" as={NavLink} to={`/users/${user._id}`}>
						Cancel
					</Button>
					<Button size="sm" colorScheme="success" isLoading={fetching} onClick={handleWhitelisting}>
						Whitelist
					</Button>
				</ButtonGroup>
			</VStack>
		</VStack>
	)
}
